export default __webpack_public_path__ + "static/media/6.548e2a59.png";